export enum VehicleModType {
	UNKNOWN = -1,

	SPOILER,
	BUMPER_F,
	BUMPER_R,
	SKIRT,
	EXHAUST,
	CHASSIS,
	GRILL,
	BONNET,
	WING_L,
	WING_R,
	ROOF,

	ENGINE,
	BRAKES,
	GEARBOX,
	HORN,
	SUSPENSION,
	ARMOUR,

	TOGGLE_NITROUS,
	TOGGLE_TURBO,
	TOGGLE_SUBWOOFER,
	TOGGLE_TYRE_SMOKE,
	TOGGLE_HYDRAULICS,
	TOGGLE_XENON_LIGHTS,

	WHEELS,
	REAR_WHEELS,

	// Lowrider
	PLTHOLDER,
	PLTVANITY,

	INTERIOR1,
	INTERIOR2,
	INTERIOR3,
	INTERIOR4,
	INTERIOR5,
	SEATS,
	STEERING,
	KNOB,
	PLAQUE,
	ICE,

	TRUNK,
	HYDRO,

	ENGINEBAY1,
	ENGINEBAY2,
	ENGINEBAY3,

	CHASSIS2,
	CHASSIS3,
	CHASSIS4,
	CHASSIS5,

	DOOR_L,
	DOOR_R,

	LIVERY,

	LIGHTBAR,
}

export enum VehicleTuningCategory {
	FRONT_BUMPER = 'front_bumper',
	REAR_BUMPER = 'rear_bumper',
	DOORS = 'doors',
	BONNET = 'bonnet',
	BOOT = 'boot',
	SKIRTS = 'skirts',
	ROOF = 'roof',
	FENDERS = 'fenders',
	LIGHTS = 'lights',
	EXHAUST = 'exhaust',
	INTERIOR = 'interior',
	CHASSIS = 'chassis',
	ENGINE = 'engine',
	RIMS = 'rims',
	KITS = 'kits',
	WHEEL_SETTINGS = 'wheel_settings',
}

export enum VehicleTuningSubcategory {
	// Передний бампер
	FRONT_BUMPER = 'front_bumper', // Передний бампер
	SPLITTER = 'splitter', // Сплиттер
	GRILLE = 'grille', // Решётка
	FRONT_BUMPER_MISC = 'front_bumper_misc', // Прочее (передний бампер)

	// Задний бампер
	REAR_BUMPER = 'rear_bumper', // Задний бампер
	DIFFUSER = 'diffuser', // Диффузор
	EXHAUST = 'exhaust', // Выхлоп (в составе заднего бампера)
	REAR_BUMPER_MISC = 'rear_bumper_misc', // Прочее (задний бампер)

	// Двери
	MIRRORS = 'mirrors', // Зеркала
	DOOR_MOLDINGS = 'door_moldings', // Дверные молдинги
	DOOR_HANDLES = 'door_handles', // Дверные ручки
	DOOR_ATTACHMENTS = 'door_attachments', // Накладки (двери)
	DOOR_MISC = 'door_misc', // Прочее (двери)

	// Капот
	BONNET = 'bonnet', // Капот
	BONNET_MISC = 'bonnet_misc', // Прочее (капот)

	// Багажник
	BOOT = 'boot', // Багажник
	BOOT_SPOILER = 'boot_spoiler', // Спойлер (багажник)
	BOOT_LIGHTS = 'boot_lights', // Фонари (багажник)
	BOOT_MISC = 'boot_misc', // Прочее (багажник)

	// Боковые юбки
	SIDE_SKIRTS = 'side_skirts', // Боковые юбки
	SIDE_ATTACHMENTS = 'side_attachments', // Накладки (боковые юбки)
	SIDE_SKIRTS_MISC = 'side_skirts_misc', // Прочее (боковые юбки)

	// Крыша
	ROOF = 'roof', // Крыша
	ROOF_SPOILER = 'roof_spoiler', // Спойлер (крыша)
	SUNROOF = 'sunroof', // Люк
	ANTENNAS = 'antennas', // Антенны
	ROOF_MOLDINGS = 'roof_moldings', // Молдинги (крыша)
	ROOF_MISC = 'roof_misc', // Прочее (крыша)

	// Крылья
	FRONT_FENDERS = 'front_fenders', // Передние крылья
	REAR_FENDERS = 'rear_fenders', // Задние крылья

	// Оптика
	FRONT_LIGHTS = 'front_lights', // Передние фары
	REAR_LIGHTS = 'rear_lights', // Задние фонари

	// Интерьер
	INTERIOR = 'interior', // Интерьер
	SEATS = 'seats', // Сиденья
	STEERING_WHEEL = 'steering_wheel', // Руль
	INTERIOR_MISC = 'interior_misc', // Прочее (интерьер)

	// Кузов
	BODY_TRIMS = 'body_trims', // Накладки (кузов)
	BODY_MISC = 'body_misc', // Прочее (кузов)

	// Двигатель
	ENGINE = 'engine', // Двигатель
	ENGINE_TRIMS = 'engine_trims', // Накладки (двигатель)
	ENGINE_MISC = 'engine_misc', // Прочее (двигатель)
}

export const categoryByTuningSubcategory: Record<VehicleTuningSubcategory, VehicleTuningCategory> = {
	[VehicleTuningSubcategory.FRONT_BUMPER]: VehicleTuningCategory.FRONT_BUMPER,
	[VehicleTuningSubcategory.SPLITTER]: VehicleTuningCategory.FRONT_BUMPER,
	[VehicleTuningSubcategory.GRILLE]: VehicleTuningCategory.FRONT_BUMPER,
	[VehicleTuningSubcategory.FRONT_BUMPER_MISC]: VehicleTuningCategory.FRONT_BUMPER,
	[VehicleTuningSubcategory.REAR_BUMPER]: VehicleTuningCategory.REAR_BUMPER,
	[VehicleTuningSubcategory.DIFFUSER]: VehicleTuningCategory.REAR_BUMPER,
	[VehicleTuningSubcategory.EXHAUST]: VehicleTuningCategory.EXHAUST,
	[VehicleTuningSubcategory.REAR_BUMPER_MISC]: VehicleTuningCategory.REAR_BUMPER,
	[VehicleTuningSubcategory.MIRRORS]: VehicleTuningCategory.DOORS,
	[VehicleTuningSubcategory.DOOR_MOLDINGS]: VehicleTuningCategory.DOORS,
	[VehicleTuningSubcategory.DOOR_HANDLES]: VehicleTuningCategory.DOORS,
	[VehicleTuningSubcategory.DOOR_ATTACHMENTS]: VehicleTuningCategory.DOORS,
	[VehicleTuningSubcategory.DOOR_MISC]: VehicleTuningCategory.DOORS,
	[VehicleTuningSubcategory.BONNET]: VehicleTuningCategory.BONNET,
	[VehicleTuningSubcategory.BONNET_MISC]: VehicleTuningCategory.BONNET,
	[VehicleTuningSubcategory.BOOT]: VehicleTuningCategory.BOOT,
	[VehicleTuningSubcategory.BOOT_SPOILER]: VehicleTuningCategory.BOOT,
	[VehicleTuningSubcategory.BOOT_LIGHTS]: VehicleTuningCategory.BOOT,
	[VehicleTuningSubcategory.BOOT_MISC]: VehicleTuningCategory.BOOT,
	[VehicleTuningSubcategory.SIDE_SKIRTS]: VehicleTuningCategory.SKIRTS,
	[VehicleTuningSubcategory.SIDE_ATTACHMENTS]: VehicleTuningCategory.SKIRTS,
	[VehicleTuningSubcategory.SIDE_SKIRTS_MISC]: VehicleTuningCategory.SKIRTS,
	[VehicleTuningSubcategory.ROOF]: VehicleTuningCategory.ROOF,
	[VehicleTuningSubcategory.ROOF_SPOILER]: VehicleTuningCategory.ROOF,
	[VehicleTuningSubcategory.SUNROOF]: VehicleTuningCategory.ROOF,
	[VehicleTuningSubcategory.ANTENNAS]: VehicleTuningCategory.ROOF,
	[VehicleTuningSubcategory.ROOF_MOLDINGS]: VehicleTuningCategory.ROOF,
	[VehicleTuningSubcategory.ROOF_MISC]: VehicleTuningCategory.ROOF,
	[VehicleTuningSubcategory.FRONT_FENDERS]: VehicleTuningCategory.FENDERS,
	[VehicleTuningSubcategory.REAR_FENDERS]: VehicleTuningCategory.FENDERS,
	[VehicleTuningSubcategory.FRONT_LIGHTS]: VehicleTuningCategory.LIGHTS,
	[VehicleTuningSubcategory.REAR_LIGHTS]: VehicleTuningCategory.LIGHTS,
	[VehicleTuningSubcategory.INTERIOR]: VehicleTuningCategory.INTERIOR,
	[VehicleTuningSubcategory.SEATS]: VehicleTuningCategory.INTERIOR,
	[VehicleTuningSubcategory.STEERING_WHEEL]: VehicleTuningCategory.INTERIOR,
	[VehicleTuningSubcategory.INTERIOR_MISC]: VehicleTuningCategory.INTERIOR,
	[VehicleTuningSubcategory.BODY_TRIMS]: VehicleTuningCategory.CHASSIS,
	[VehicleTuningSubcategory.BODY_MISC]: VehicleTuningCategory.CHASSIS,
	[VehicleTuningSubcategory.ENGINE]: VehicleTuningCategory.ENGINE,
	[VehicleTuningSubcategory.ENGINE_TRIMS]: VehicleTuningCategory.ENGINE,
	[VehicleTuningSubcategory.ENGINE_MISC]: VehicleTuningCategory.ENGINE,
};

export const subcategoryByModType: Partial<Record<VehicleModType, VehicleTuningSubcategory>> = {
	[VehicleModType.BUMPER_F]: VehicleTuningSubcategory.FRONT_BUMPER,
	[VehicleModType.BUMPER_R]: VehicleTuningSubcategory.REAR_BUMPER,
	[VehicleModType.GRILL]: VehicleTuningSubcategory.GRILLE,
	[VehicleModType.EXHAUST]: VehicleTuningSubcategory.EXHAUST,
	[VehicleModType.DOOR_L]: VehicleTuningSubcategory.MIRRORS,
	[VehicleModType.DOOR_R]: VehicleTuningSubcategory.MIRRORS,
	[VehicleModType.BONNET]: VehicleTuningSubcategory.BONNET,
	[VehicleModType.TRUNK]: VehicleTuningSubcategory.BOOT,
	[VehicleModType.SPOILER]: VehicleTuningSubcategory.BOOT_SPOILER,
	[VehicleModType.SKIRT]: VehicleTuningSubcategory.SIDE_SKIRTS,
	[VehicleModType.ROOF]: VehicleTuningSubcategory.ROOF,
	[VehicleModType.CHASSIS3]: VehicleTuningSubcategory.ANTENNAS,
	[VehicleModType.CHASSIS4]: VehicleTuningSubcategory.ROOF_MOLDINGS,
	[VehicleModType.WING_L]: VehicleTuningSubcategory.FRONT_FENDERS,
	[VehicleModType.WING_R]: VehicleTuningSubcategory.FRONT_FENDERS,
	[VehicleModType.INTERIOR1]: VehicleTuningSubcategory.INTERIOR,
	[VehicleModType.INTERIOR2]: VehicleTuningSubcategory.INTERIOR,
	[VehicleModType.INTERIOR3]: VehicleTuningSubcategory.INTERIOR,
	[VehicleModType.INTERIOR4]: VehicleTuningSubcategory.INTERIOR,
	[VehicleModType.INTERIOR5]: VehicleTuningSubcategory.INTERIOR,
	[VehicleModType.ICE]: VehicleTuningSubcategory.INTERIOR_MISC,
	[VehicleModType.SEATS]: VehicleTuningSubcategory.SEATS,
	[VehicleModType.STEERING]: VehicleTuningSubcategory.STEERING_WHEEL,
	[VehicleModType.CHASSIS]: VehicleTuningSubcategory.BODY_TRIMS,
	[VehicleModType.CHASSIS2]: VehicleTuningSubcategory.BODY_TRIMS,
	[VehicleModType.CHASSIS5]: VehicleTuningSubcategory.BODY_TRIMS,
	[VehicleModType.ENGINEBAY1]: VehicleTuningSubcategory.ENGINE,
	[VehicleModType.ENGINEBAY2]: VehicleTuningSubcategory.ENGINE_TRIMS,
	[VehicleModType.ENGINEBAY3]: VehicleTuningSubcategory.ENGINE_MISC,
};

/** Высота профиля шины */
export enum VehicleWheelTireProfile {
	LOW = 'low',
	MEDIUM = 'medium',
	HIGH = 'high',
}

export const vehicleTireProfileOrder = [
	VehicleWheelTireProfile.HIGH,
	VehicleWheelTireProfile.MEDIUM,
	VehicleWheelTireProfile.LOW,
];

export function getTireProfileIndex(type: VehicleWheelTireProfile): number | null {
	const index = vehicleTireProfileOrder.findIndex((e) => e === type);
	return index !== -1 ? index : null;
}

export const VEHICLE_TIRE_PROFILE_NAMES: Record<VehicleWheelTireProfile, string> = {
	[VehicleWheelTireProfile.LOW]: 'Низкий',
	[VehicleWheelTireProfile.MEDIUM]: 'Средний',
	[VehicleWheelTireProfile.HIGH]: 'Высокий',
};

/** Тип покрытия диска */
export enum VehicleRimPaintType {
	PEARL = 'pearl',
	MATTE = 'matte',
	CHROME = 'chrome',
}

export const vehicleRimPaintTypesOrder = [
	VehicleRimPaintType.PEARL,
	VehicleRimPaintType.MATTE,
	VehicleRimPaintType.CHROME,
];

export function getRimPaintTypeIndex(type: VehicleRimPaintType): number | null {
	const index = vehicleRimPaintTypesOrder.findIndex((e) => e === type);
	return index !== -1 ? index : null;
}

export const VEHICLE_RIM_PAINT_TYPE_NAMES: Record<VehicleRimPaintType, string> = {
	[VehicleRimPaintType.PEARL]: 'Глянец',
	[VehicleRimPaintType.MATTE]: 'Матовый',
	[VehicleRimPaintType.CHROME]: 'Хром',
};

export const VEHICLE_RIM_PAINT_TYPE_NAMES_PLURAL: Record<VehicleRimPaintType, string> = {
	[VehicleRimPaintType.PEARL]: 'Обычные',
	[VehicleRimPaintType.MATTE]: 'Матовые',
	[VehicleRimPaintType.CHROME]: 'Хром',
};

export enum VehicleWheelsSetting {
	FRONT_CAMBER = 'fc',
	REAR_CAMBER = 'rc',
	FRONT_OFFSET = 'fo',
	REAR_OFFSET = 'ro',
	RADIUS = 'r',
	WIDTH = 'w',
}

export interface IVehicleWheelsSettings {
	[VehicleWheelsSetting.FRONT_CAMBER]: number;
	[VehicleWheelsSetting.REAR_CAMBER]: number;
	[VehicleWheelsSetting.FRONT_OFFSET]: number;
	[VehicleWheelsSetting.REAR_OFFSET]: number;
	[VehicleWheelsSetting.RADIUS]: number;
	[VehicleWheelsSetting.WIDTH]: number;
}

export interface IVehicleWheelsSettingsRanges {
	[VehicleWheelsSetting.FRONT_CAMBER]: [number, number];
	[VehicleWheelsSetting.REAR_CAMBER]: [number, number];
	[VehicleWheelsSetting.FRONT_OFFSET]: [number, number];
	[VehicleWheelsSetting.REAR_OFFSET]: [number, number];
	[VehicleWheelsSetting.RADIUS]: [number, number];
	[VehicleWheelsSetting.WIDTH]: [number, number];
}

export interface IVehicleTuning {
	/**
	 * Список ID предметов-деталей тюнинга
	 */
	items?: string[];
	/**
	 * ID кита
	 */
	itemsKit?: string;
	/**
	 * Параметры колес
	 */
	wheels?: IVehicleWheelsSettings;
	/**
	 * Профиль шин
	 */
	tiresProfile?: VehicleWheelTireProfile;
}
